module.exports = __webpack_public_path__ + "img/confirmed.3e654d0a.svg";